import { render } from "./ResearchForPlant.vue?vue&type=template&id=09dc2454"
import script from "./ResearchForPlant.vue?vue&type=script&lang=js"
export * from "./ResearchForPlant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__